import { changeIbanApi } from '~/app/features/required-change-iban/util/api.consts';
import { requestChangeIbanErrors } from '~/app/features/required-change-iban/util/error.consts';

export class IbanInvalidError extends Error {
  constructor() {
    super(requestChangeIbanErrors.invalidIbanMessage);
    this.name = requestChangeIbanErrors.invalidIbanError;
  }
}

export class RequiredChangeIbanService {
  constructor(ctx) {
    this._ctx = ctx;
  }

  async changeIban(iban, onSuccessHandler) {
    const response = await this._ctx.$api.dispatch(changeIbanApi.changeBankRequisites, {
      iban,
    });

    if (!response.success) {
      throw new IbanInvalidError();
    }

    onSuccessHandler();

    return response;
  }
}
